import React, { useState } from 'react';
import RatesForm from './ratesForm';
import MainPickupPage from '../pickup';
import MainSummaryPage from '../summary';
interface Props {
  setShowRatesForm: any;
  setCurrentShipmentStatus: any;
}
function MainRatesPage({ setShowRatesForm, setCurrentShipmentStatus }: Props) {
  const [showPickup, setShowPickup] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  return (
    <div>
      {!showPickup && !showSummary ? (
        <RatesForm
          setShowRatesForm={setShowRatesForm}
          setShowPickup={setShowPickup}
          setShowSummary={setShowSummary}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      ) : showSummary ? (
        <MainSummaryPage
          setShowSummary={setShowSummary}
          setShowRates={setShowRatesForm}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      ) : (
        <MainPickupPage
          setShowPickup={setShowPickup}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      )}
    </div>
  );
}

export default MainRatesPage;
